/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../shared/services/common.service';
import { MarketService } from 'app/shared/services/market.service';

@Injectable()

export class LoginService {
  private loginUrl: string = environment.host + '/login';
  private logoutUrl: string = environment.host + '/logout';
  private userUrl: string = environment.host + '/profile';
  private translationsUrl: string = environment.host + '/translation/getAllLanguageTranslationsByLocaleAndSourceType';
  private resetPasswordUrl: string = environment.host + '/reset';
  private user: any = 'defaultUser';
  private homePageMetadata: any = [];
  private timeZoneInfo: any;

  constructor(private http: HttpClient, private commonService: CommonService,private marketService: MarketService,) {
  }

  ngOnInit() {
    // if company code exists, user is logged-in
    // else avoid call bcz api will give 401
    const companyCode = this.commonService.getCompanyCode();
    if (companyCode) {
      this.getGlobalSettings(null);
      this.getAllMarkets();
    }
    this.setTimeZoneBasedOnCalendarDefination();
  }

  public getGlobalSettings(payload: any) {
      this.commonService.getGlobalSettings(payload)
        .then(this.getGlobalSettingsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  public getGlobalSettingsSH(res: any) {
    let dtObj, dateFormatObj;
    const dateObj = res.filter(function (resObj: any) {
      return (resObj.code == "DTFMT");
    });
    if (dateObj.length) {
      if (dateObj[0].value.split("/").length) {
        dtObj = dateObj[0].value.split("/");
      } else if (dateObj[0].value.split("-").length) {
        dtObj = dateObj[0].value.split("-");
      }
      const dateFormatArr = dtObj, cDateFormatArr: any = [];
      dateFormatArr.forEach(function (dtf: any) {
        cDateFormatArr.push(dtf.toUpperCase());
      });
      if (dateObj[0].value.split("/").length) {
        dateFormatObj = cDateFormatArr.join("/");
      } else {
        dateFormatObj = cDateFormatArr.join("-");
      }
      this.commonService.setDateFormat(dateFormatObj);
    }
    
    // try {
    //   const localeCode = res.find((x: any) => x.code === 'CF').value;
    //   const localeCurrency = res.find((x: any) => x.code === 'CC').value;
    //   this.commonService.setLocale(localeCode, localeCurrency);
    // } catch(e) {
    // }
  }

  public getAllMarkets() {
    this.marketService
      .getAllMarkets()
      .then(this.getAllMarketsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getAllMarketsSH(data: any) {
    for (const market of data) {
      const eachMarket = market,
        regions = eachMarket.regions || [];
      if (regions.length) {
        for (const region of regions) {
          try {
            const localeCode = region.currencyFormat;
            const localeCurrency = region.currency;
            this.commonService.setLocale(localeCode, localeCurrency);
          } catch (e) {
          }
        }
      }
    }
  }

  public setTimeZoneBasedOnCalendarDefination() {
    const companyCode = this.commonService.getCompanyCode();
    if (companyCode) {
      this.commonService.getCalendarDefinitionTabType(companyCode)
        .then(this.getCalendarDefinitionSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private getCalendarDefinitionSH(res: any) {
    if (res) {
      this.timeZoneInfo = res.timeZone || 'America/Los_Angeles';
      this.setTimeZonInfo(this.timeZoneInfo);
    }
  }

  public authenticateLoginDetails(payload: any) {
    let formData = new FormData(),
      authenticateUrl;
    formData.append('username', payload.username);
    formData.append('password', payload.password);
    authenticateUrl = this.loginUrl.toString();
    return this.http.post(authenticateUrl, formData).toPromise();
  }

  public resetPasswordDetails(mail: any) {
    const resetPasswordUrl = this.resetPasswordUrl.toString(),
      payload: any = {};
    payload.emailId = mail;
    return this.http.put(resetPasswordUrl, payload).toPromise();
  }

  public authenticateLogOutDetails() {
    const authenticateUrl = this.logoutUrl.toString();
    this.commonService.setUserDetails('');
    return this.http.get(authenticateUrl).toPromise();
  }

  public getUserProfileDetails() {
    const userProfileUrl = this.userUrl.toString();
    return this.http.get(userProfileUrl).toPromise();
  }

  public getTransaltionLabels(locale: any) {
    const translationsUrl = this.translationsUrl.toString() + `?locale=${locale}&sourceType=ui`;
    return this.http.get(translationsUrl).toPromise();
  }

  public setUser(user: any) {
    this.user = user;
  }

  public getUser() {
    return this.user;
  }

  public getHomePageMetaData() {
    const url = environment.host + '/homePage';
    return this.http.get(url).toPromise();
  }

  public setTimeZonInfo(timeZoneInfo: any) {
    this.timeZoneInfo = timeZoneInfo;
    localStorage.setItem('calendarBasedTimeZone', timeZoneInfo); /*getTimeZoneInfo() function is not returning timezone when page is opened in new window or on refresh, thats why setting timezone in localstorage and using */
    this.commonService.setTimeZonInfo(timeZoneInfo);
  }

  public getHomePages() {
    return this.homePageMetadata;
  }

  public setHomePages(items: any) {
    this.homePageMetadata = items;
  }

  //VCE-27296
  public getAppVersion() {
    const url = environment.host + '/application/appVersion'
    return this.http.get(url).toPromise();
  }

  public getDeploymentAbout() {
    const url = environment.host + '/deployment/about';
    return this.http.get(url).toPromise();
  }
}
